<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Team building" subTitle="" srcImg="/images/pages/image-title-menu.jpg"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="team_building" breadcrumb1="" breadcrumb2="Team building" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Team bulding - Liens équipe",
  meta: [
    {
      name: "description",
      content: "Le Team building ou construction d’équipe est une pratique permettant de renforcer les liens entre les membres d’une équipeautour d’une activité ludique, sportive ou culturelle."
    }
  ]
})
</script>

<style scoped>
.body {
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>